import { render, staticRenderFns } from "./BUGDetail.vue?vue&type=template&id=d721971e&scoped=true&"
import script from "./BUGDetail.vue?vue&type=script&lang=js&"
export * from "./BUGDetail.vue?vue&type=script&lang=js&"
import style0 from "./BUGDetail.vue?vue&type=style&index=0&id=d721971e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d721971e",
  null
  
)

export default component.exports